import api from './api';

/** Ein geänderter Text der öffentlichen Website, wie ihn das Backend zurückgibt. */
export interface SiteText {
  key: string;
  value: string;
  updatedAt?: string;
  updatedBy?: string;
}

/**
 * Schreibender Zugang zu den Website-Texten — nur für Rolle ADMIN
 * (`/api/admin/**` in SecurityConfig).
 *
 * Gelesen werden die Texte nicht hier, sondern über den öffentlichen Endpunkt in
 * `website/publicApi.ts`: Die Website muss ohne Login funktionieren.
 */
export const siteTextService = {
  /** Alle Änderungen samt Bearbeiter und Zeitpunkt. */
  async getAll(): Promise<SiteText[]> {
    const response = await api.get<SiteText[]>('/admin/site-texts');
    return response.data;
  },

  async save(key: string, value: string): Promise<SiteText> {
    const response = await api.put<SiteText>(`/admin/site-texts/${encodeURIComponent(key)}`, { value });
    return response.data;
  },

  /** Setzt die Textstelle auf den ausgelieferten Originaltext zurück. */
  async reset(key: string): Promise<void> {
    await api.delete(`/admin/site-texts/${encodeURIComponent(key)}`);
  },
};

export default siteTextService;
